import { render, staticRenderFns } from "./UserAssignIssues.vue?vue&type=template&id=34563992&scoped=true"
import script from "./UserAssignIssues.vue?vue&type=script&lang=ts"
export * from "./UserAssignIssues.vue?vue&type=script&lang=ts"
import style0 from "./UserAssignIssues.vue?vue&type=style&index=0&id=34563992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34563992",
  null
  
)

export default component.exports